// extracted by mini-css-extract-plugin
module.exports = {"memberLink":"ReportedBy-module__memberLink___v1-RM","user":"ReportedBy-module__user___gVNBF","postedTime":"ReportedBy-module__postedTime___J5H9Z"};